import type { PersonalProject } from '@portfolio/shared';

/**
 * Personal projects, kept separate from employed work so the distinction stays
 * obvious. Content is exactly as supplied by Constantin: no technology stack is
 * listed, because none was recorded for this project.
 */
export const personalProjects: readonly PersonalProject[] = [
  {
    id: 'personareply',
    name: 'PersonaReply',
    url: 'https://personareply.com/',
    displayUrl: 'personareply.com',
    tagline: 'AI-generated replies driven by configurable personas',
    summary:
      'An AI-powered platform that helps users generate personalized, context-aware replies using ' +
      'configurable personas. Users define different communication styles, personalities and ' +
      'tones, which lets the AI produce responses adapted to a specific conversation and audience.',
    highlights: [
      'Designed an intuitive dashboard for creating, configuring and managing AI personas.',
      'Built workflows for generating relevant replies based on conversation context, selected tone and persona characteristics.',
      'Integrated generative AI capabilities to deliver natural, personalized and consistent responses.',
      'Focused on prompt engineering, response quality, usability and a clean, responsive user experience.',
      'Structured the application to support additional personas, communication scenarios and AI models as the platform evolves.',
    ],
    focus: ['Generative AI', 'Persona configuration', 'Prompt engineering', 'Responsive UI'],
    outcome:
      'A practical use of generative AI to make digital communication faster, more personalized ' +
      'and more effective.',
  },
];
